import React from 'react'

import { errorBackgroundColor, primaryTextColor } from '../../../../lib/styles/colors'
import Banner from '../Banner'

type DangerBannerProps = {
  /** Content to display in the danger banner */
  children: React.ReactNode
  /** Optional css class name */
  className?: string
  /** Optional icon to apply to the banner */
  icon?: React.ReactNode
  /** Optional className for the icon to apply additional styles */
  iconClassName?: string
  /** Optional icon color */
  iconColor?: string
  /** Optional className for banner content */
  innerClassName?: string
}

const defaultProps: Pick<
  DangerBannerProps,
  'className' | 'icon' | 'iconClassName' | 'iconColor' | 'innerClassName'
> = {
  className: undefined,
  icon: undefined,
  iconClassName: undefined,
  iconColor: primaryTextColor,
  innerClassName: undefined
}

const DangerBanner = ({
  children,
  className,
  icon,
  iconClassName,
  iconColor,
  innerClassName
}: DangerBannerProps) => (
  <Banner
    className={className}
    icon={icon}
    backgroundColor={errorBackgroundColor}
    iconClassName={iconClassName}
    iconColor={iconColor}
    innerClassName={innerClassName}
  >
    {children}
  </Banner>
)

DangerBanner.defaultProps = defaultProps

export default DangerBanner
